import { autoinject } from "aurelia-framework";
import download from "downloadjs";

import { IBlobResponse } from "../resources-vue/vue-interfaces/i-hospice-client";

@autoinject
export class DownloadService {
    public downloadFile(file: IBlobResponse, type = "application/pdf") {
        let fileName = this.extractFileNameFromResponseHeader(file);
        this.downloadFileWithFileName(file, type, fileName);
    }

    public downloadFileWithFileName(file: IBlobResponse, type = "application/pdf", fileName: string) {
        // Convert ArrayBuffer to Blob if necessary
        const fileBody = file.body instanceof ArrayBuffer ? new Blob([file.body], { type }) : file.body;
        download(fileBody, fileName, type);
    }

    public extractMimeTypeFromResponseHeader(header: IBlobResponse): string {
        const fileName = this.extractFileNameFromResponseHeader(header);
        const ext = fileName.split(".").pop().toLowerCase();
        const mimeMap = {
            png: "image/png",
            jpg: "image/jpeg",
            jpeg: "image/jpeg",
            gif: "image/gif",
            pdf: "application/pdf",
            txt: "text/plain",
            xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            docx: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
            zip: "application/zip"
        };
        return !ext ? null : mimeMap[ext];
    }

    private extractFileNameFromResponseHeader(response: IBlobResponse): string {
        let responseHeader: string = response.headers.get("content-disposition");
        const resp = responseHeader.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/)[1].replace(/^"+|"+$/g, "");
        return resp;
    }
}
